// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1R1M0","title":"Images90_title__t9bh4","images":"Images90_images__25ptH"};